import React from 'react';
import {render} from "react-dom";
import App from './js/App';
import thunkMiddleware from "redux-thunk";
import {applyMiddleware, createStore} from "redux";
import reducer from "./js/reducers";
import {LocaleProvider} from "antd";
import enUS from "antd/lib/locale-provider/en_US";
import "antd/dist/antd.css";
import "./css/index.css";
import "./css/App.css";


const store = createStore(
    reducer, applyMiddleware(
        thunkMiddleware
    )
);


render(
    <LocaleProvider locale={enUS}>
        <App store={store}/>
    </LocaleProvider>
    , 
    document.getElementById('root')
);


// WEBPACK FOOTER //
// ./src/index.js